// extracted by mini-css-extract-plugin
export default {"sectionOneWrapper":"Intro_sectionOneWrapper__0jg9Q","sectionOneTile":"Intro_sectionOneTile__jBlO3","imgTile":"Intro_imgTile__DTgbj","textTile":"Intro_textTile__pvFzE"};